function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" == typeof define && define.amd ? define("vue-scroll-sync", [], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["vue-scroll-sync"] = e() : t["vue-scroll-sync"] = e();
}(global, function () {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        n.d(r, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 7);
  }([function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = 0;
    e["default"] = {
      props: {
        proportional: Boolean,
        vertical: Boolean,
        horizontal: Boolean,
        group: String
      },
      data: function data() {
        return {
          topNode: null
        };
      },
      beforeCreate: function beforeCreate() {
        this.uuid = r.toString(), r += 1;
      },
      mounted: function mounted() {
        for (var t = this, e = this.$parent; e;) {
          this.topNode = e, e = this.topNode.$parent;
        }

        this.topNode.$on("scroll-sync", function (e) {
          if (e.emitter !== t.uuid && e.group === t.group) {
            var n = e.scrollTop,
                r = e.scrollHeight,
                o = e.clientHeight,
                i = e.scrollLeft,
                s = e.scrollWidth,
                c = e.clientWidth,
                l = e.barHeight,
                a = e.barWidth,
                u = r - o,
                f = s - c,
                d = t.proportional,
                p = t.vertical,
                h = t.horizontal,
                v = t.$el.scrollHeight - o,
                _ = t.$el.scrollWidth - c;

            t.$el.onscroll = null, p && u > l && (t.$el.scrollTop = d ? v * n / u : n), h && f > a && (t.$el.scrollLeft = d ? _ * i / f : i), window.requestAnimationFrame(function () {
              t.$el.onscroll = t.handleScroll;
            });
          }
        }), this.$el.onscroll = this.handleScroll;
      },
      methods: {
        handleScroll: function handleScroll(t) {
          var e = this,
              n = this;
          window.requestAnimationFrame(function () {
            var r = t.target,
                o = r.scrollTop,
                i = r.scrollHeight,
                s = r.clientHeight,
                c = r.scrollLeft,
                l = r.scrollWidth,
                a = r.clientWidth,
                u = r.offsetHeight,
                f = r.offsetWidth;
            e.topNode.$emit("scroll-sync", {
              scrollTop: o,
              scrollHeight: i,
              clientHeight: s,
              scrollLeft: c,
              scrollWidth: l,
              clientWidth: a,
              barHeight: u - s,
              barWidth: f - a,
              emitter: n.uuid,
              group: n.group
            });
          });
        }
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return r;
    }), n.d(e, "b", function () {
      return o;
    });

    var r = function r() {
      var t = this.$createElement;
      return (this._self._c || t)("div", {
        staticClass: "scroll-sync-container"
      }, [this._t("default")], 2);
    },
        o = [];

    r._withStripped = !0;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r, o, i, s, c) {
      var l = _typeof((t = t || {})["default"]);

      "object" !== l && "function" !== l || (t = t["default"]);
      var a,
          u = "function" == typeof t ? t.options : t;
      if (e && (u.render = e, u.staticRenderFns = n, u._compiled = !0), r && (u.functional = !0), i && (u._scopeId = i), s ? (a = function a(t) {
        (t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), o && o.call(this, t), t && t._registeredComponents && t._registeredComponents.add(s);
      }, u._ssrRegister = a) : o && (a = c ? function () {
        o.call(this, this.$root.$options.shadowRoot);
      } : o), a) if (u.functional) {
        u._injectStyles = a;
        var f = u.render;

        u.render = function (t, e) {
          return a.call(e), f(t, e);
        };
      } else {
        var d = u.beforeCreate;
        u.beforeCreate = d ? [].concat(d, a) : [a];
      }
      return {
        exports: t,
        options: u
      };
    }

    n.d(e, "a", function () {
      return r;
    });
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      if (r || "undefined" == typeof __VUE_SSR_CONTEXT__ || (r = __VUE_SSR_CONTEXT__), r) {
        r.hasOwnProperty("styles") || (Object.defineProperty(r, "styles", {
          enumerable: !0,
          get: function get() {
            return o(r._styles);
          }
        }), r._renderStyles = o);
        var i = r._styles || (r._styles = {});
        e = function (t, e) {
          for (var n = [], r = {}, o = 0; o < e.length; o++) {
            var i = e[o],
                s = i[0],
                c = {
              id: t + ":" + o,
              css: i[1],
              media: i[2],
              sourceMap: i[3]
            };
            r[s] ? r[s].parts.push(c) : n.push(r[s] = {
              id: s,
              parts: [c]
            });
          }

          return n;
        }(t, e), n ? function (t, e) {
          for (var n = 0; n < e.length; n++) {
            for (var r = e[n].parts, o = 0; o < r.length; o++) {
              var i = r[o],
                  s = i.media || "default",
                  c = t[s];
              c ? c.ids.indexOf(i.id) < 0 && (c.ids.push(i.id), c.css += "\n" + i.css) : t[s] = {
                ids: [i.id],
                css: i.css,
                media: i.media
              };
            }
          }
        }(i, e) : function (t, e) {
          for (var n = 0; n < e.length; n++) {
            for (var r = e[n].parts, o = 0; o < r.length; o++) {
              var i = r[o];
              t[i.id] = {
                ids: [i.id],
                css: i.css,
                media: i.media
              };
            }
          }
        }(i, e);
      }
    }

    function o(t) {
      var e = "";

      for (var n in t) {
        var r = t[n];
        e += '<style data-vue-ssr-id="' + r.ids.join(" ") + '"' + (r.media ? ' media="' + r.media + '"' : "") + ">" + r.css + "</style>";
      }

      return e;
    }

    n.r(e), n.d(e, "default", function () {
      return r;
    });
  }, function (t, e) {
    t.exports = function (t) {
      var e = [];
      return e.toString = function () {
        return this.map(function (e) {
          var n = function (t, e) {
            var n = t[1] || "",
                r = t[3];
            if (!r) return n;

            if (e && "function" == typeof btoa) {
              var o = (s = r, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(s)))) + " */"),
                  i = r.sources.map(function (t) {
                return "/*# sourceURL=" + r.sourceRoot + t + " */";
              });
              return [n].concat(i).concat([o]).join("\n");
            }

            var s;
            return [n].join("\n");
          }(e, t);

          return e[2] ? "@media " + e[2] + "{" + n + "}" : n;
        }).join("");
      }, e.i = function (t, n) {
        "string" == typeof t && (t = [[null, t, ""]]);

        for (var r = {}, o = 0; o < this.length; o++) {
          var i = this[o][0];
          "number" == typeof i && (r[i] = !0);
        }

        for (o = 0; o < t.length; o++) {
          var s = t[o];
          "number" == typeof s[0] && r[s[0]] || (n && !s[2] ? s[2] = n : n && (s[2] = "(" + s[2] + ") and (" + n + ")"), e.push(s));
        }
      }, e;
    };
  }, function (t, e, n) {
    (t.exports = n(4)(!1)).push([t.i, "\n.scroll-sync-container[data-v-12cf087e] {\n    width:100%;\n    height:100%;\n    overflow:auto;\n    position: relative;\n}\n", ""]);
  }, function (t, e, n) {
    var r = n(5);
    "string" == typeof r && (r = [[t.i, r, ""]]), r.locals && (t.exports = r.locals);
    var o = n(3)["default"];

    t.exports.__inject__ = function (t) {
      o("aecd5d52", r, !1, t);
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0),
        o = n.n(r);

    for (var i in r) {
      "default" !== i && function (t) {
        n.d(e, t, function () {
          return r[t];
        });
      }(i);
    }

    var s = n(1),
        c = n(2);

    var l = function l(t) {
      var e;
      (e = n(6)).__inject__ && e.__inject__(t);
    },
        a = Object(c.a)(o.a, s.a, s.b, !1, l, "data-v-12cf087e", "ed1ef43e");

    a.options.__file = "src/ScrollSync.vue", e["default"] = a.exports;
  }]);
});